import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=856ea1c0"
import script from "./MediaCard.vue?vue&type=script&lang=ts"
export * from "./MediaCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports